import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  createExportInputSchema,
  emptyInputSchema,
  exportFileSchema,
  exportIdInputSchema,
  exportListSchema,
  exportSchema,
} from "./export.schemas.ts";

export const exportTrpcContract = defineTrpcContract("export", {
  list: query({ input: emptyInputSchema, output: exportListSchema }),
  get: query({ input: exportIdInputSchema, output: exportSchema }),
  file: query({ input: exportIdInputSchema, output: exportFileSchema }),
  create: mutation({ input: createExportInputSchema, output: exportSchema }),
  retry: mutation({ input: exportIdInputSchema, output: exportSchema }),
});
